import React, { useEffect, useState } from "react";
import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import { MaterialReactTable } from "material-react-table";
import { Edit, Delete } from "@mui/icons-material"; // Importing Material UI icons
import { FaFileInvoice, FaMailBulk, FaWhatsapp } from "react-icons/fa";
import SubmitButton from "components/SubmitButton/SubmitButton";
import userResources from "api/userResources";
import { AiOutlineClose, AiOutlineInfoCircle } from "react-icons/ai";
import UserInfoModal from "components/UserInfoModal/UserInfoModal";
import { avtar } from "utils/images";
import ConfirmModal from "components/ConfirmModal/ConfirmModal";
import DateFilter from "components/DateFilter/DateFilter";
import SelectFilter from "components/SelectFilter/SelectFilter";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../../redux/userSlice";
import { toast } from "react-toastify";
import getStatusTextColor from "components/StatusColorFunction/StatusColorFunction";
import { paymentStatusDummyDataWithId } from "components/PaymentStatusData/PaymentStatusData";
import Widget from "components/widget/Widget";
import { RiMessage2Line } from "react-icons/ri";
import { IoReloadOutline } from "react-icons/io5";
import FollowUpModal from "components/FollowUpModal/FollowUpModal";
import Modal from "components/daisyUiMsgModal/Modal";
export default function EnquiryList({
  api,
  searchComponentParams,
  searchComponent,
}) {
  const userInfo = useSelector(selectUserInfo);
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const [title, setTitle] = useState("");
  const [invoice, setInvoice] = useState("");
  const [type, setType] = useState("");
  const [fromFilter, setFromFilter] = useState("");
  const [toFilter, setToFilter] = useState("");
  const [enquiryIdFilter, setEnquiryIdFilter] = useState("");
  const [customer_name, setCustomerName] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [verifyFilter, setVerifyFilter] = useState("");
  const [bookingReference, setBookingReference] = useState("");
  const [enquiry_payment_status, setEnquiryPaymentStatus] = useState(null);
  const [enquiryPaymentStausData, setEnquiryPaymentStatusData] = useState([]);
  const [enquiry_source_id, setEnquirySourceId] = useState(null);
  const [enquiryData, setEnquiryData] = useState([]);
  const [transaction_type_id, setTransaction_type_id] = useState(null);
  const [transactionTypeData, setTransactionTypeData] = useState([]);
  const [enquiryStausData, setEnquiryStatusData] = useState([]);
  const [enquiry_status_id, setEnquiryStatusId] = useState(null);
  const [AssignToData, setAssignToData] = useState([]);
  const [AssignToUserId, setAssignToUserId] = useState(null);
  const [createdByData, setCreatedByData] = useState([]);
  const [createdById, setCreatedById] = useState(null);
  const [updatedById, setUpdatedById] = useState(null);
  const [statusFilter, setStatusFilter] = useState({});
  const [air_line_id, setAirLineId] = useState(null);
  const [airlineData, setAirlineData] = useState([]);
  const [columnsFilterValue, setColumnsFilterValue] = useState([]);
  const [departureDateFilterValue, setDepartureDateFilterValue] = useState("");
  const [returnDateFilterDate, setReturnDateFilterDate] = useState("");
  const [createdAtFilterDate, setCreatedAtFilterDate] = useState("");
  const [startDate, setStartDate] = useState(location?.state?.startDate || "");
  const [endDate, setEndDate] = useState(location?.state?.endDate || "");
  const [updatedFilterDate, setUpdatedFilterDate] = useState("");
  const [budgetRange, setBudgetRange] = useState({ min: "", max: "" });
  const [paymentState, setPaymentState] = useState({});
  const [followUpData, setFollowUpData] = useState({});
  const [isFollowUpModalOpen, setIsFollowUpModalOpen] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState(""); // State for modal
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false); // State for modal visibility

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenModal = (assignedUser) => {
    setUserProfile(assignedUser);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setUserProfile({}); // Reset user profile on close
  };

  const handleFollowUpModalOpen = (data) => {
    setFollowUpData(data);
    setIsFollowUpModalOpen(true);
  };
  const handleFollowUpModalClose = () => {
    setIsFollowUpModalOpen(false);
    setFollowUpData(null); // Reset user profile on close
  };

  const filter = {
    title: title || null,
    type: type || null,
    enquiry_code: enquiryIdFilter || null,
    customer_name: customer_name || null,
    email: globalFilter || emailFilter || searchComponentParams?.email || "",
    invoice_number: invoice || searchComponentParams?.invoice_number || null,
    phone_number: phone_number || searchComponentParams?.phone_number || null,
    air_line_id:
      location?.state?.thisSearchFor?.name === "airlinesStatics"
        ? location?.state?.id
        : air_line_id || null,
    from: fromFilter || "",
    to: toFilter || "",
    booking_reference:
      bookingReference || searchComponentParams?.booking_reference || null,
    departure_date: departureDateFilterValue || null,
    return_date: returnDateFilterDate || null,
    enquiry_payment_status:
      location?.state?.thisSearchFor?.name === "enquiryPaymentStatus"
        ? location?.state?.id
        : enquiry_payment_status || null,
    transaction_type_id:
      location?.state?.thisSearchFor?.name === "enquirytransactiontypeid"
        ? location?.state?.id
        : transaction_type_id || null,
    enquiry_source_id:
      location?.state?.thisSearchFor?.name === "enquirySourceStatus"
        ? location?.state?.id
        : enquiry_source_id || null,
    enquiry_status_id: enquiry_status_id || null,
    created_by_user_id: location?.state?.filterWithEmployee
      ? location?.state?.filterWithEmployee?.CreatedUserid
      : createdById
      ? createdById
      : api === "createdenquiryList"
      ? userInfo.data.id
      : null,
    assigned_to_user_id: location?.state?.filterWithEmployee
      ? location?.state?.filterWithEmployee?.id
      : AssignToUserId
      ? AssignToUserId
      : api === "assignenquirylist"
      ? userInfo.data.id
      : null,
    max_price: budgetRange.max || null || null, // Set max_price if budgetRange.max exists
    min_price: budgetRange.min || null || null, // Set min_price if budgetRange.min exists
    created_at_date: createdAtFilterDate || null,
    updated_at_date: updatedFilterDate || null,
    updated_by_user_id: updatedById || null,
    status:
      location?.state?.thisSearchFor?.name === "pendingEnquirys"
        ? location?.state?.id
        : statusFilter || null,
    start_date: startDate
      ? new Date(new Date(startDate).getTime() - 24 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0]
      : null,
    end_date: endDate
      ? new Date(new Date(endDate).getTime() + 24 * 60 * 60 * 1000) // add 1 day
          .toISOString()
          .split("T")[0] // format to YYYY-MM-DD
      : null,
    admin_payment_status:
      location?.state?.thisSearchFor?.name === "enquiryPaymentApprovel"
        ? location?.state?.id
        : verifyFilter,
  };

  const getEnquiryList = async (
    pageIndex = 0, // Default to 0 if not provided
    pageSize = 10, // Default to 10 if not provided
    globalFilter = "",
    filterValues = {}
  ) => {
    setIsLoading(true); // Start loading state
    setIsError(false); // Reset error state

    try {
      const params = {
        page: pageIndex + 1, // Convert to 1-based index for API
        limit: pageSize,
        email: globalFilter, // Filter by email or global search
        ...filterValues, // Additional filters
      };
      if (location?.state?.reminderEnquiry) {
        params.enquiry_code = location?.state?.reminderEnquiry;
      }

      const response = await userResources.enquiryListAll(params);

      // Update state with API response
      setTotalRows(response?.data?.paginate_data?.total || 0); // Total rows for pagination
      setData(response?.data?.data || []); // Main data array
    } catch (error) {
      console.error("Error fetching enquiry list:", error);
      setIsError(true); // Set error state
      setData([]); // Clear data on error
    } finally {
      setIsLoading(false); // End loading state
    }
  };

  const formatData = (data, key) =>
    data.map((item) => ({
      id: item?.id,
      name: item?.[key],
    }));

  const handleApiResult = (result, setter, key, label) => {
    if (result.status === "fulfilled") {
      setter(formatData(result.value.data.data, key));
    } else {
      console.error(`Error fetching ${label} data:`, result.reason);
    }
  };

  const getEnquirySource = async () => {
    try {
      const results = await Promise.allSettled([
        userResources.getSources(),
        userResources.airlines(),
        userResources.enquityStatus(),
        userResources.userList({ role_id: "", size: 9999 }),
        userResources.transactionType(),
      ]);

      const [
        enquirySourceResult,
        airlineResult,
        enquiryStatusResult,
        allUserResult,
        transactionType,
      ] = results;

      const apiResults = [
        {
          result: enquirySourceResult,
          setter: setEnquiryData,
          key: "name",
          label: "Enquiry Source",
        },
        {
          result: airlineResult,
          setter: setAirlineData,
          key: "airline_name",
          label: "Airline",
        },
        {
          result: enquiryStatusResult,
          setter: setEnquiryStatusData,
          key: "name",
          label: "Enquiry Status",
        },
        {
          result: allUserResult,
          setter: setAssignToData,
          key: "name",
          label: "User List",
        },
        {
          result: allUserResult,
          setter: setCreatedByData,
          key: "name",
          label: "All User List",
        },
        {
          result: transactionType,
          setter: setTransactionTypeData,
          key: "name",
          label: "Transaction Type",
        },
      ];

      apiResults.forEach(({ result, setter, key, label }) => {
        handleApiResult(result, setter, key, label);
      });

      setEnquiryPaymentStatusData(paymentStatusDummyDataWithId);
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  // Utility function to format a date as DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const dateObj = new Date(dateString);
    if (isNaN(dateObj)) return "Invalid Date"; // Handle invalid date inputs

    // Format date to DD-MM-YYYY
    const formattedDate = dateObj
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");
    return formattedDate;
  };

  const adminPaymentApproval = async (data) => {
    try {
      const response = await userResources.adminPaymentApprovel(data);
      // Show success message
      toast.success(
        response?.data?.message || "Payment status updated successfully!",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );

      // Refresh enquiry list after approval
      getEnquiryList(
        pagination.pageIndex,
        pagination.pageSize,
        globalFilter,
        filter
      );
    } catch (error) {
      // Show error message
      toast.error(
        error.response?.data?.message || "Failed to update payment status.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );

      console.error("Error:", error);
    }
  };

  // info modal
  const handleModalOpen = (experience) => {
    setSelectedExperience(experience); // Set the travel experience text
    setIsModalInfoOpen(true); // Open the modal
  };

  const handleModalClose = () => {
    setIsModalInfoOpen(false); // Close the modal
    setSelectedExperience(""); // Reset the travel experience
  };

  // Column definitions for the table
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "assignedToUser",
        header: "Assigned To",
        filterVariant: "select",
        enableColumnFilter: api === "assignenquirylist" ? false : true, // Enable filter for this column
        Filter: ({ column }) => (
          <SelectFilter
            options={AssignToData}
            selectedId={AssignToUserId}
            setSelectedId={setAssignToUserId}
            column={column}
            placeholder="Assign to..."
          />
        ),
        Cell: ({ cell }) => {
          const assignedUser = cell.getValue();

          return (
            <div className="flex items-center gap-2">
              {assignedUser ? (
                <div className="tooltip" data-tip="Profile">
                  <img
                    onClick={() => handleOpenModal(assignedUser)} // Wrap in an arrow function for passing data
                    className="h-10 w-10 cursor-pointer rounded-full"
                    src={assignedUser?.full_path}
                    alt={assignedUser?.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = avtar; // Default avatar
                    }}
                  />
                </div>
              ) : (
                "N/A"
              )}
              {assignedUser && (
                <div>
                  <p>{assignedUser?.name}</p>
                  <p>{assignedUser?.phone_no}</p>
                </div>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "status",
        header: "Status",
        enableColumnFilter: true, // Disable filter for this column
        Filter: ({ column }) => (
          <SelectFilter
            options={[
              { id: "pending", name: "Pending" },
              { id: "reject", name: "Rejected" },
              { id: "accept", name: "Accepted" },
            ]}
            selectedId={statusFilter}
            setSelectedId={setStatusFilter}
            column={column}
            placeholder="Status Filter"
            getStatusColor={getStatusTextColor}
          />
        ),
        Cell: ({ row, cell }) => {
          const status = cell.getValue();
          const statusName = status;

          return (
            <div>
              {api === "assignenquirylist" ||
              (row?.original?.assignedToUser?.id === userInfo?.data?.id &&
                status !== "accept") ? (
                <select
                  name={"status"}
                  className={`relative inline-flex cursor-pointer items-center gap-2 rounded-md border border-gray-300 bg-white px-4 py-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${getStatusTextColor(
                    statusName
                  )}`}
                  disabled={status === "accept" ? true : false}
                  onChange={async (e) => {
                    const data = {
                      id: row.original.id,
                      status: e.target.value,
                    };
                    try {
                      const response =
                        await userResources.assignEnquiryAccepter(data); // Call the API with ID and status
                      console.log(response);
                      if (response.status) {
                        toast.success(response?.data?.message?.flash_message);
                      }

                      getEnquiryList(
                        pagination.pageIndex,
                        pagination.pageSize,
                        globalFilter,
                        filter
                      );

                      console.log(response);
                    } catch (error) {
                      console.log(error);
                    }
                  }} // Handle status change
                >
                  <option value={statusName}>{statusName}</option>
                  <option value="reject">Reject</option>
                  <option value="accept">Accept</option>
                </select>
              ) : (
                <div className="relative inline-flex items-center gap-1">
                  <p className={getStatusTextColor(statusName)}>{statusName}</p>
                </div>
              )}
            </div>
          );
        },
      },
      // {
      //   accessorKey: "title",
      //   header: "Title",
      //   Cell: ({ cell }) => cell.getValue() || "N/A",
      //   enableColumnFilter: true, // Enable filter for this column
      // },
      {
        accessorKey: "customer_name",
        header: "Customer Name",
        Cell: ({ cell }) => cell.getValue() || "N/A",
        enableColumnFilter: true, // Enable filter for this column
      },
      {
        accessorKey: "email",
        header: "Email Address",
        enableClickToCopy: true,
        Cell: ({ cell }) => cell.getValue() || "N/A",
        enableColumnFilter: true, // Enable filter for this column
      },
      {
        accessorKey: "phone_number",
        header: "Phone Number",
        Cell: ({ cell }) => cell.getValue() || "N/A",
        enableColumnFilter: true, // Enable filter for this column
      },
      {
        accessorKey: "enquiry_code",
        header: "Enquiry ID",
        enableColumnFilter: true, // Disable filter for this column
      },
      {
        accessorKey: "enquirySource",
        header: "Enquiry Source",
        Cell: ({ cell }) => cell.getValue()?.name || "N/A",
        filterVariant: "select",
        Filter: ({ column }) => (
          <SelectFilter
            options={enquiryData}
            selectedId={enquiry_source_id}
            setSelectedId={setEnquirySourceId}
            column={column}
            placeholder="Select Enquiry Source"
          />
        ),
      },
      {
        accessorKey: "type",
        header: "Type",
        Cell: ({ cell }) => cell.getValue() || "N/A",
        enableColumnFilter: true, // Enable filter for this column
      },

      {
        accessorKey: "fromAirport",
        header: "From",
        enableColumnFilter: true, // Enable filter for this column
        Cell: ({ cell }) => {
          const fromAirport = cell.getValue();
          const AirportName = fromAirport?.name || "N/A"; // Use the name property for display

          return (
            <div className="relative inline-flex items-center gap-1">
              <span className="group relative ml-2 cursor-pointer">
                {/* Info Icon */}
                <AiOutlineInfoCircle className="text-orange-500" />
                {/* Tooltip */}
                <span className="absolute -top-8 left-0 hidden w-48 bg-gray-700 p-2 text-xs text-white group-hover:block">
                  <strong>Status Info:</strong>
                  <br />
                  Airport: {AirportName || ""}
                  <br />
                  ID: {fromAirport?.id || "N/A"}
                </span>
              </span>
              <span>{AirportName || ""}</span>
            </div>
          );
        },
        // filterVariant: "select",
      },
      {
        accessorKey: "toAirport",
        header: "To",
        enableColumnFilter: true, // Enable filter for this column
        Cell: ({ cell }) => {
          const toAirport = cell.getValue();
          const AirportName = toAirport?.name || "N/A"; // Use the name property for display

          return (
            <div className="relative inline-flex items-center gap-1">
              <span className="group relative ml-2 cursor-pointer">
                {/* Info Icon */}
                <AiOutlineInfoCircle className="text-orange-500" />
                {/* Tooltip */}
                <span className="absolute -top-8 left-0 hidden w-48 bg-gray-700 p-2 text-xs text-white group-hover:block">
                  <strong>Status Info:</strong>
                  <br />
                  Airport: {AirportName || ""}
                  <br />
                  ID: {toAirport?.id || "N/A"}
                </span>
              </span>
              <span>{AirportName || ""}</span>
            </div>
          );
        },
        // filterVariant: "select",
      },
      {
        accessorKey: "departure_date",
        header: "Departure Date",
        Filter: ({ column }) => (
          <DateFilter
            column={column}
            selectedDate={departureDateFilterValue}
            setSelectedDate={setDepartureDateFilterValue}
          />
        ),
        Cell: ({ cell }) => formatDate(cell.getValue()), // Use the utility function
        enableColumnFilter: true, // Enable filter for this column
      },
      {
        accessorKey: "return_date",
        header: "Return Date",
        Cell: ({ cell }) => formatDate(cell.getValue()), // Use the utility function
        Filter: ({ column }) => (
          <DateFilter
            column={column}
            selectedDate={returnDateFilterDate}
            setSelectedDate={setReturnDateFilterDate}
          />
        ),
      },
      {
        header: "Traveler Details",
        enableColumnFilter: false, // Enable filter for this column

        Cell: ({ row }) => {
          const adult = row.original.adult ?? "N/A";
          const child = row.original.child ?? "N/A";
          const infant = row.original.infant ?? "N/A";
          const classOfTravel = row.original.class_of_travel ?? "N/A";

          return (
            <div className="whitespace-nowrap">
              <p>Adults: {adult}</p>
              <p>Children: {child}</p>
              <p>Infants: {infant}</p>
              <p>Class: {classOfTravel}</p>
            </div>
          );
        },
      },
      {
        accessorKey: "airLine",
        header: "Preferred Airline",
        enableColumnFilter: true,
        Cell: ({ cell }) => {
          const airline = cell.getValue();
          return airline?.airline_name || "N/A";
        },
        filterVariant: "select",
        Filter: ({ column }) => (
          <SelectFilter
            options={airlineData}
            selectedId={air_line_id}
            setSelectedId={setAirLineId}
            column={column}
            placeholder="Select Airline"
          />
        ),
      },
      {
        accessorKey: "budget",
        header: "Budget",
        Cell: ({ cell }) => {
          // Function to generate a random color
          const getRandomColor = () => {
            const letters = "0123456789ABCDEF";
            let color = "#";
            for (let i = 0; i < 6; i++) {
              color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
          };
          // Function to determine if a color is light or dark
          const isColorLight = (color) => {
            // Convert hex to RGB
            const r = parseInt(color.slice(1, 3), 16);
            const g = parseInt(color.slice(3, 5), 16);
            const b = parseInt(color.slice(5, 7), 16);
            // Calculate the brightness (perceived brightness)
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            return brightness > 155; // Adjust threshold for light vs. dark
          };

          const randomColor = getRandomColor();
          const textColor = isColorLight(randomColor) ? "#000" : "#fff"; // Black for light, white for dark

          return (
            <div
              style={{
                backgroundColor: randomColor, // Set random color
                borderRadius: "0.25rem",
                color: textColor, // Set dynamic text color
                maxWidth: "15ch",
                padding: "0.25rem",
              }}
            >
              {cell.getValue()?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </div>
          );
        },
        filterFn: (row, columnId, filterValue) => {
          const budget = row.getValue(columnId);
          const { min, max } = filterValue || {};
          return (
            (min === "" || budget >= parseFloat(min)) &&
            (max === "" || budget <= parseFloat(max))
          );
        },
        // Add custom filter UI
        Filter: () => (
          <div className="grid grid-cols-2 items-center gap-2">
            <div className="relative">
              <input
                type="number"
                placeholder="Min"
                value={budgetRange.min}
                onChange={(e) => {
                  const value = e.target.value;
                  setBudgetRange((prev) => ({ ...prev, min: value }));
                }}
                style={{ padding: "5px" }}
                className="border-b bg-transparent text-gray-900 outline-none"
              />
              {budgetRange.min && (
                <button
                  onClick={() =>
                    setBudgetRange((prev) => ({ ...prev, min: "" }))
                  }
                  className="absolute right-0 top-1/2 -translate-y-1/2 transform"
                  aria-label="Clear Min Budget"
                >
                  <AiOutlineClose size={16} />
                </button>
              )}
            </div>
            <div className="relative">
              <input
                type="number"
                placeholder="Max"
                value={budgetRange.max}
                onChange={(e) => {
                  const value = e.target.value;
                  setBudgetRange((prev) => ({ ...prev, max: value }));
                }}
                style={{ padding: "5px" }}
                className="border-b bg-transparent text-gray-900 outline-none"
              />
              {budgetRange.max && (
                <button
                  onClick={() =>
                    setBudgetRange((prev) => ({ ...prev, max: "" }))
                  }
                  className="absolute right-0 top-1/2 -translate-y-1/2 transform"
                  aria-label="Clear Max Budget"
                >
                  <AiOutlineClose size={16} />
                </button>
              )}
            </div>
          </div>
        ),
      },
      {
        accessorKey: "paid_amount", // This is the new column for budget
        header: "Paid Amount",
        enableColumnFilter: false, // Enable filter for this column

        Cell: ({ cell }) => {
          // Function to generate a random color
          const getRandomColor = () => {
            const letters = "0123456789ABCDEF";
            let color = "#";
            for (let i = 0; i < 6; i++) {
              color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
          };
          // Function to determine if a color is light or dark
          const isColorLight = (color) => {
            // Convert hex to RGB
            const r = parseInt(color.slice(1, 3), 16);
            const g = parseInt(color.slice(3, 5), 16);
            const b = parseInt(color.slice(5, 7), 16);
            // Calculate the brightness (perceived brightness)
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            return brightness > 155; // Adjust threshold for light vs. dark
          };

          const randomColor = getRandomColor();
          const textColor = isColorLight(randomColor) ? "#000" : "#fff"; // Black for light, white for dark

          return (
            <div
              style={{
                backgroundColor: randomColor, // Set random color
                borderRadius: "0.25rem",
                color: textColor, // Set dynamic text color
                maxWidth: "15ch",
                padding: "0.25rem",
              }}
            >
              {cell.getValue()?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </div>
          );
        },
      },

      {
        accessorKey: "payment_details.pending_amount",
        header: "Pending Amount",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => {
          const pendingAmount = row?.original?.payment_details?.pending_amount; // Get pending amount
          const budget = row.original.budget; // Get budget amount

          // Determine background and text colors
          let textColor = "black";

          if (pendingAmount === 0) {
            textColor = "gray";
          } else if (pendingAmount === budget) {
            textColor = "red";
          } else if (pendingAmount < budget) {
            textColor = "orange";
          }

          return (
            <div
              style={{
                color: textColor,
                borderRadius: "0.25rem",
                maxWidth: "15ch",
                padding: "0.25rem",
              }}
            >
              {pendingAmount?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </div>
          );
        },
      },
      {
        accessorKey: "payment_details.overPaidAmount",
        header: "Over Paid Amount",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => {
          const overPaidAmount = row?.original?.payment_details?.overPaidAmount; // Get pending amount
          const budget = row.original.budget; // Get budget amount

          // Determine background and text colors
          let textColor = "black";

          if (overPaidAmount > 0) {
            textColor = "#006400";
          } else {
            textColor = "gray";
          }

          return (
            <div
              style={{
                color: textColor,
                borderRadius: "0.25rem",
                maxWidth: "15ch",
                padding: "0.25rem",
              }}
            >
              {overPaidAmount?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </div>
          );
        },
      },
      {
        accessorKey: "transactionType",
        header: " Transaction Type",
        Cell: ({ cell }) => cell.getValue()?.name || "N/A",
        filterVariant: "select",
        Filter: ({ column }) => (
          <SelectFilter
            options={transactionTypeData}
            selectedId={transaction_type_id}
            setSelectedId={setTransaction_type_id}
            column={column}
            placeholder="Select  Transaction Type"
          />
        ),
      },
      {
        accessorKey: "enquiry_payment_status", // Adjust this to match your actual data structure
        header: "Payment Status",
        filterVariant: "select",
        enableColumnFilter: true, // Enable filter for this column
        Filter: ({ column }) => (
          <SelectFilter
            options={enquiryPaymentStausData}
            selectedId={enquiry_payment_status}
            setSelectedId={setEnquiryPaymentStatus}
            column={column}
            placeholder="Select enquiry payment status"
          />
        ),
        Cell: ({ cell }) => {
          const paymentStatus = cell.getValue();

          // Helper function to convert status to formatted display text
          const formatPaymentStatus = (status) => {
            const formattedStatus = {
              over_paid: "Over Paid",
              paid: "Paid",
              pending: "Pending",
              not_paid: "Not Paid",
            };
            return formattedStatus[status] || status; // Fallback to original if status is not in the map
          };

          // Function to determine text color based on payment status
          const getPaymentStatusTextColor = (status) => {
            switch (status) {
              case "over_paid":
                return "text-green-800 "; // Green for Paid/Over Paid
              case "paid":
                return "text-green-500"; // Green for Paid/Over Paid
              case "pending":
                return "text-orange-500"; // Orange for Pending
              case "not_paid":
                return "text-red-600"; // Red for Not Paid
              default:
                return "text-gray-600"; // Default gray for unknown status
            }
          };

          return (
            <p>
              <span className={getPaymentStatusTextColor(paymentStatus)}>
                {formatPaymentStatus(paymentStatus)}
              </span>
            </p>
          );
        },
      },
      {
        accessorKey: "admin_payment_status",
        header: "Verify Payment",
        enableClickToCopy: true,
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue();
          const rowId = row.original.id;
          const isSuperAdminOrAdmin =
            userInfo?.data.role_id == process.env.REACT_APP_ROLE_SUPERADMIN ||
            userInfo?.data.role_id == process.env.REACT_APP_ROLE_ADMIN;

          if (isSuperAdminOrAdmin && currentValue === "pending") {
            return (
              <select
                className={`relative inline-flex cursor-pointer items-center gap-2 rounded-md border border-gray-300 bg-white px-4 py-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 `}
                value={paymentState[rowId] || "pending"}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setPaymentState((prevState) => ({
                    ...prevState,
                    [rowId]: newValue,
                  }));
                  if (newValue === "approved") {
                    adminPaymentApproval({
                      id: rowId,
                      admin_payment_status: newValue,
                    });
                  }
                }}
                style={{
                  color:
                    paymentState[rowId] === "approved" ? "green" : "orange",
                }}
              >
                <option value="pending" disabled>
                  Pending
                </option>
                <option value="approved" className="text-green-500 ">
                  Approved
                </option>
              </select>
            );
          }

          // Default text rendering
          let textColor = "black";
          let value = "";
          if (currentValue === "no_action") {
            textColor = "gray";
            value = "No action";
          } else if (currentValue === "pending") {
            textColor = "orange";
            value = "Pending";
          } else if (currentValue === "approved") {
            textColor = "green";
            value = "Approved";
          }

          return (
            <span
              style={{
                color: textColor,
              }}
            >
              {value || "N/A"}
            </span>
          );
        },
      },
      {
        accessorKey: "enquiryStatus", // Adjust this to match your actual data structure
        header: "Enquiry Status",
        filterVariant: "select",
        enableColumnFilter: true, // Enable filter for this column
        Filter: ({ column }) => (
          <SelectFilter
            options={enquiryStausData}
            selectedId={enquiry_status_id}
            setSelectedId={setEnquiryStatusId}
            column={column}
            placeholder="Select enquiry status"
          />
        ),
        Cell: ({ cell }) => {
          const enquiryStatus = cell.getValue();
          const statusName = enquiryStatus?.name || "N/A"; // Use the name property for display

          return (
            <div className="relative inline-flex items-center gap-1">
              <span className="group relative ml-2 cursor-pointer">
                {/* Info Icon */}
                <AiOutlineInfoCircle className="text-gray-600 hover:text-gray-800" />
                {/* Tooltip */}
                <span className="absolute -top-8 left-0 hidden w-48 bg-gray-700 p-2 text-xs text-white group-hover:block">
                  <strong>Status Info:</strong>
                  <br />
                  ID: {enquiryStatus?.id || "N/A"}
                  <br />
                  Status: {statusName}
                </span>
              </span>
              <span>{statusName}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "booking_reference",
        header: "Booking Reference",
        enableColumnFilter: true, // Enable filter for this column
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      // {
      //   accessorKey: "invoice_number",
      //   header: "Invoice",
      //   Cell: ({ cell }) => cell.getValue() || "N/A",
      //   enableColumnFilter: true, // Enable filter for this column
      // },
      {
        accessorKey: "remark",
        header: "Remarks",
        enableColumnFilter: false, // Enable filter for this column
        Cell: ({ row }) => (
          <button
            className="btn-bg-orange-500 btn btn-sm"
            onClick={() => handleModalOpen(row.original.remark)}
          >
            Open
          </button>
        ),
      },
      {
        accessorKey: "created_at", // Adjust this to match your actual data structure
        header: "Created Date",
        filterVariant: "select",
        enableColumnFilter: true, // Enable filter for this column
        Filter: ({ column }) => (
          <DateFilter
            column={column}
            selectedDate={createdAtFilterDate}
            setSelectedDate={setCreatedAtFilterDate}
          />
        ),

        Cell: ({ cell }) => {
          const createdAt = new Date(cell.getValue());
          const date = createdAt.toLocaleDateString(); // Get the date portion
          const time = createdAt.toLocaleTimeString(); // Get the time portion

          return (
            <div className="flex flex-col">
              <p
                className="font-semibold
              "
              >
                Date: <span className="font-light">{date}</span>
              </p>{" "}
              {/* Display the date */}
              <p
                className="font-semibold
              "
              >
                Time: <span className="font-light">{time}</span>
              </p>{" "}
              {/* Display the time */}
            </div>
          );
        },
      },
      {
        accessorKey: "updated_at", // Adjust this to match your actual data structure
        header: "Updated Date",
        enableColumnFilter: true, // Enable filter for this column
        Filter: ({ column }) => (
          <DateFilter
            column={column}
            selectedDate={updatedFilterDate}
            setSelectedDate={setUpdatedFilterDate}
          />
        ),
        Cell: ({ cell }) => {
          const updatedAt = new Date(cell.getValue());
          const date = updatedAt.toLocaleDateString(); // Get the date portion
          const time = updatedAt.toLocaleTimeString(); // Get the time portion

          return (
            <div className="flex flex-col">
              <p
                className="font-semibold
              "
              >
                Date: <span className="font-light">{date}</span>
              </p>{" "}
              {/* Display the date */}
              <p
                className="font-semibold
              "
              >
                Time: <span className="font-light">{time}</span>
              </p>{" "}
              {/* Display the time */}
            </div>
          );
        },
      },

      {
        accessorKey: "createdByUser",
        header: "Created By",
        enableColumnFilter: api === "createdenquiryList" ? false : true, // Enable filter for this column
        Filter: ({ column }) => (
          <SelectFilter
            options={createdByData}
            selectedId={createdById}
            setSelectedId={setCreatedById}
            column={column}
            placeholder="created By..."
          />
        ),
        Cell: ({ cell }) => {
          const assignedBy = cell.getValue();

          return (
            <div className="flex items-center gap-2">
              <div className="tooltip" data-tip="Profile">
                <img
                  onClick={() => handleOpenModal(assignedBy)} // Wrap in an arrow function
                  className="h-10 w-10 cursor-pointer rounded-full"
                  src={assignedBy?.full_path}
                  alt={assignedBy?.name}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = avtar; // Default avatar
                  }}
                />
              </div>
              <div>
                <p>{assignedBy?.name}</p>
                <p>{assignedBy?.phone_no}</p>
              </div>
            </div>
          );
        },
      },
      // {
      //   accessorKey: "updatedByUser",
      //   header: "updated By",
      //   enableColumnFilter: true, // Enable filter for this column
      //   Filter: ({ column }) => (
      //     <SelectFilter
      //       options={createdByData}
      //       selectedId={updatedById}
      //       setSelectedId={setUpdatedById}
      //       column={column}
      //       placeholder="Updated By..."
      //     />
      //   ),
      //   Cell: ({ cell }) => {
      //     const assignedBy = cell.getValue();
      //     return (
      //       <div className="flex items-center gap-2">
      //         {assignedBy ? (
      //           <>
      //             <div className="tooltip" data-tip="Profile">
      //               <img
      //                 onClick={() => handleOpenModal(assignedBy)} // Wrap in an arrow function for passing data
      //                 className="h-10 w-10 cursor-pointer rounded-full"
      //                 src={assignedBy?.full_path}
      //                 alt={assignedBy?.name || "User Avatar"}
      //                 onError={(e) => {
      //                   e.target.onerror = null;
      //                   e.target.src = avtar; // Default avatar
      //                 }}
      //               />
      //             </div>
      //             <div>
      //               <p>{assignedBy?.name}</p>
      //               <p>{assignedBy?.phone_no}</p>
      //             </div>
      //           </>
      //         ) : (
      //           "N/A"
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        accessorKey: "followed_up_at",
        header: "Followed Up Date",
        enableColumnFilter: false,
        Cell: ({ cell, row }) => {
          const rowData = {
            assign_user_id: row?.original?.assignedToUser?.id,
            enquiry_id: row?.original?.id,
          };

          return (
            <button
              className="rounded-md bg-black p-2 text-sm font-light text-white"
              onClick={() => handleFollowUpModalOpen(rowData)}
            >
              Set followUp
            </button>
          );
        },
      },

      {
        accessorKey: "history",
        header: "History",
        enableColumnFilter: false, // Enable filter for this column
        Cell: ({ row }) => (
          <div
            className="flex space-x-1"
            onClick={() =>
              navigate("/admin/enquiry-history", {
                state: row?.original?.children,
              })
            }
          >
            <SubmitButton
              add="History"
              extraClass={"bg-purple-500 hover:bg-purple-700 rounded-lg"}
            />
          </div>
        ),
      },
      // {
      //   accessorKey: "invoices",
      //   header: "Invoice",
      //   enableColumnFilter: false, // Enable filter for this column
      //   Cell: ({ row }) => (
      //     <div>
      //       {row?.original?.invoices.length > 0 ? (
      //         <div
      //           className="flex space-x-1"
      //           onClick={() =>
      //             navigate("/admin/invoice-list", {
      //               state: row?.original,
      //             })
      //           }
      //         >
      //           <SubmitButton
      //             add="Invoice"
      //             extraClass={"bg-green-500 rounded-lg"}
      //           />
      //         </div>
      //       ) : (
      //         "Empty"
      //       )}
      //     </div>
      //   ),
      // },
      {
        accessorKey: "action",
        header: "Action",
        enableColumnFilter: false, // Enable filter for this column
        Cell: ({ row }) => (
          <div className="flex items-center space-x-2">
            <Edit
              className="cursor-pointer text-blue-500"
              onClick={() => {
                const { package_type } = row.original; // Destructure for cleaner access
                const rowDataWithNavigateTo = {
                  ...row.original,
                  NavigateTo: api,
                };

                if (package_type === "multi_city") {
                  navigate(`/admin/create-enquiry/flight/multi-city`, {
                    state: rowDataWithNavigateTo,
                  });
                } else if (package_type === "return_way") {
                  navigate(`/admin/create-enquiry/flight/round-trip`, {
                    state: rowDataWithNavigateTo,
                  });
                } else if (package_type === "one_way") {
                  navigate(`/admin/create-enquiry/flight/oneway`, {
                    state: rowDataWithNavigateTo,
                  });
                }
              }}
            />

            {userInfo?.data?.role_id ===
              Number(process.env.REACT_APP_ROLE_SUPERADMIN) ||
            userInfo?.data?.role_id ===
              Number(process.env.REACT_APP_ROLE_ADMIN) ? (
              <ConfirmModal
                onConfirm={handleDelete}
                title="Delete Enquiry"
                message="Are you sure you want to delete this enquiry?"
                employeeId={row.original.id}
              />
            ) : null}
            {/* <div className="tooltip" data-tip="Create Invoice">
              <FaFileInvoice
                size={18}
                color="#4CAF50"
                className="cursor-pointer"
                onClick={() => {
                  navigate(`/admin/create-new-invoice/air-ticket`, {
                    state: row?.original,
                  }); // Navigate with row data
                }}
              />
            </div> */}
          </div>
        ),
      },
    ],
    [
      data,
      columnsFilterValue,
      enquiryData,
      transactionTypeData,
      transaction_type_id,
      enquiry_source_id,
      departureDateFilterValue,
      returnDateFilterDate,
      createdAtFilterDate,
      air_line_id,
      updatedFilterDate,
      enquiry_status_id,
      enquiry_payment_status,
      AssignToUserId,
      createdById,
      budgetRange,
      updatedById,
      statusFilter,
    ]
  );

  const handleDelete = async (id) => {
    // Show loading toast
    const loadingToastId = toast.loading("Deleting enquiry...");

    try {
      await userResources.enquiryDelete(id); // Attempt to delete the airline

      // Update toast to show success
      toast.update(loadingToastId, {
        render: "Enquiry deleted successfully.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
      });

      // Refresh the enquiry list
      getEnquiryList(
        pagination.pageIndex,
        pagination.pageSize,
        globalFilter,
        filter
      );
    } catch (error) {
      console.error("Error deleting enquiry:", error);

      // Update toast to show error
      const errorMessage =
        error.response?.data?.message ||
        "Failed to delete enquiry. Please try again.";
      toast.update(loadingToastId, {
        render: errorMessage,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      // Dismiss the loading toast if not already dismissed
      if (toast.isActive(loadingToastId)) {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const sendEmailToAll = () => {
    const emails = data.map((item) => item.email).join(",");
    const subject = "Hello Everyone!";
    const body = "Hi Team,\n\n";
    const mailtoLink = `mailto:${emails}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink);
  };

  // pagination
  const handleGlobalFilterChange = (value) => {
    setGlobalFilter(value); // Update the global filter state with the new value
  };
  const handlePaginationChange = (updatedPagination) => {
    setPagination(updatedPagination);
  };

  // console.log(columnsFilterValue, "columnsFilterValue");

  const handleFilterValues = () => {
    let titleFound = false;
    let nameFound = false;
    let phoneFound = false;
    let emailFound = false;
    let fromFound = false;
    let toFound = false;
    let booking_reference_Found = false;
    let typeFound = false;
    let invoiceFound = false;
    let varifyFound = false;
    let enquiryIdFound = false;
    columnsFilterValue.forEach((key) => {
      if (key.id === "customer_name") {
        setCustomerName(key.value);
        nameFound = true;
      } else if (key.id === "phone_number") {
        setPhoneNumber(key.value);
        phoneFound = true;
      } else if (key.id === "email") {
        setEmailFilter(key.value);
        emailFound = true;
      } else if (key.id === "title") {
        setTitle(key.value);
        titleFound = true;
      } else if (key.id === "booking_reference") {
        setBookingReference(key.value);
        booking_reference_Found = true;
      } else if (key.id === "type") {
        setType(key.value);
        typeFound = true;
      } else if (key.id === "invoice_number") {
        setInvoice(key.value);
        invoiceFound = true;
      } else if (key.id === "admin_payment_status") {
        setVerifyFilter(key.value);
        varifyFound = true;
      } else if (key.id === "fromAirport") {
        setFromFilter(key.value);
        fromFound = true;
      } else if (key.id === "toAirport") {
        setToFilter(key.value);
        toFound = true;
      } else if (key.id === "enquiry_code") {
        setEnquiryIdFilter(key.value);
        enquiryIdFound = true;
      }
    });

    // If keys were not found, set values to null
    if (!nameFound) {
      setCustomerName(null);
    }
    if (!phoneFound) {
      setPhoneNumber(null);
    }
    if (!emailFound) {
      setEmailFilter(null);
    }
    if (!titleFound) {
      setTitle(null);
    }
    if (!booking_reference_Found) {
      setBookingReference(null);
    }
    if (!typeFound) {
      setType(null);
    }
    if (!invoiceFound) {
      setInvoice(null);
    }
    if (!varifyFound) {
      setVerifyFilter(null);
    }
    if (!fromFound) {
      setFromFilter(null);
    }
    if (!toFound) {
      setToFilter(null);
    }
    if (!enquiryIdFound) {
      setEnquiryIdFilter(null);
    }
  };

  useEffect(() => {
    handleFilterValues();
  }, [columnsFilterValue]);

  useEffect(() => {
    getEnquiryList(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      filter
    );
  }, [
    pagination,
    globalFilter,
    enquiryIdFilter,
    customer_name,
    title,
    fromFilter,
    toFilter,
    departureDateFilterValue,
    returnDateFilterDate,
    emailFilter,
    phone_number,
    air_line_id,
    enquiry_payment_status,
    enquiry_source_id,
    AssignToUserId,
    bookingReference,
    enquiry_status_id,
    type,
    isError,
    createdById,
    invoice,
    createdAtFilterDate,
    updatedFilterDate,
    updatedById,
    statusFilter,
    startDate,
    endDate,
    transaction_type_id,
    verifyFilter,
  ]);

  useEffect(() => {
    const delay = setTimeout(() => {
      getEnquiryList(
        pagination.pageIndex,
        pagination.pageSize,
        globalFilter,
        filter
      );
    }, 1000); // 1 second delay

    return () => clearTimeout(delay); // Clear timeout if min or max changes within 1 second
  }, [budgetRange.max, budgetRange.min]);

  useEffect(() => {
    // filter.enquiry_code = location?.state?.reminderEnquiry;
    setEnquiryIdFilter(location?.state?.reminderEnquiry);
  }, [location?.state?.reminderEnquiry]);
  useEffect(() => {
    getEnquirySource();
    getEnquiryList(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      filter
    );
  }, []);

  return (
    <section className="mx-2 mt-0 sm:mt-5">
      <ScrollToTopOnRouteChange />
      <div
        className={`mb-4 grid grid-cols-1 items-center justify-between gap-4 ${
          location?.state?.name
            ? "md:grid-cols-3"
            : "sm:grid-cols-1 md:grid-cols-2"
        }`}
      >
        {/* <button
          onClick={sendEmailToAll}
          className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
        >
          Send Email to All
        </button> */}

        {location?.state?.name && (
          <Widget
            title={location?.state?.name + " Enquirys"}
            icon={
              location?.state?.filterWithEmployee?.image ? (
                <div className="flex h-[45px] w-[45px] items-center justify-center overflow-hidden rounded-full border-0 border-white bg-pink-400 dark:!border-navy-700">
                  <img
                    className="h-full w-full  rounded-full"
                    src={location?.state?.filterWithEmployee?.image}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = avtar; // Default avatar
                    }}
                    alt="Selected"
                  />
                </div>
              ) : (
                <RiMessage2Line className="h-7 w-7 text-purple-500 dark:text-white" />
              )
            }
            imagePadding={
              location?.state?.filterWithEmployee?.image ? "p-0" : "p-2"
            }
            heading={location?.state?.filterWithEmployee?.name}
            // subtitle={`${data?.totalEnquiries || 0}`}
            cardClasses={"h-16"}
            cardbgColor={"bg-purple-500 cursor-pointer"}
            titleColor={"text-white"}
          />
        )}
        {/* <button className="btn">{location?.state?.name} Enquirys</button> */}
        <div className="grid grid-cols-1 gap-4 rounded-[20px] bg-gray-300 p-2 dark:bg-white sm:grid-cols-2">
          <label
            className={`flex items-end justify-between gap-5 whitespace-nowrap text-sm font-medium text-gray-900 ${
              location?.state?.name ? "sm:flex-col sm:gap-0" : ""
            } sm:items-start `}
          >
            Start Date:{" "}
            <DateFilter
              selectedDate={startDate}
              setSelectedDate={setStartDate}
            />
          </label>
          <label
            className={`flex items-end justify-between gap-5 whitespace-nowrap text-sm font-medium text-gray-900 ${
              location?.state?.name ? "sm:flex-col sm:gap-0" : ""
            } sm:items-start `}
          >
            End Date:{" "}
            <DateFilter selectedDate={endDate} setSelectedDate={setEndDate} />
          </label>
        </div>
        <SubmitButton
          onClick={sendEmailToAll}
          add="Send Email to All"
          extraClass={
            "h-full bg-green-500 hover:bg-green-700 rounded-[20px] mt-2 sm:mt-0"
          }
        />
        {/* <button
          onClick={sendWhatsAppToAll}
          className="rounded bg-green-600 px-4 py-2 text-white hover:bg-green-700"
        >
          Send WhatsApp to All
        </button> */}
      </div>

      {/* Modal for User Info */}
      <div className="">
        {isModalOpen && (
          <UserInfoModal user={userProfile} onClose={handleCloseModal} />
        )}
      </div>

      <div>
        {isFollowUpModalOpen && (
          <FollowUpModal
            followUpData={followUpData}
            onClose={handleFollowUpModalClose}
            followupable_type={"flight"}
          />
        )}
      </div>

      <MaterialReactTable
        columns={columns}
        data={data}
        actions={[
          {
            icon: () => (
              <button
                onClick={() => alert("Button clicked!")}
                className="ml-2 rounded bg-blue-500 px-4 py-2 text-white"
              >
                Custom Button
              </button>
            ),
            isFreeAction: true,
          },
        ]}
        title="My Custom Table"
        state={{
          pagination,
          isLoading,
          showProgressBars: isLoading,
          showAlertBanner: isError,
          // columnFilters: columnsFilterValue,
        }} // Use both states here
        muiToolbarAlertBannerProps={
          isError
            ? {
                color: "error",
                children: "Error loading data",
              }
            : undefined
        }
        enableColumnFilters={
          location?.state?.disabledFilter === false || searchComponent === true
            ? false
            : true
        }
        initialState={{
          showColumnFilters:
            location?.state?.disabledFilter === false ||
            searchComponent === true
              ? false
              : true,
        }}
        onColumnFiltersChange={setColumnsFilterValue}
        enableSorting={false}
        enableColumnOrdering={false}
        enableRowActions
        enablePagination
        onPaginationChange={handlePaginationChange}
        manualPagination
        rowCount={totalRows}
        pageCount={Math.ceil(totalRows / pagination.pageSize)}
        isLoading={isLoading}
        muiTablePaginationProps={{
          showFirstButton: true,
          showLastButton: true,
        }}
        enableGlobalFilter // Keep this true to allow global filtering
        onGlobalFilterChange={handleGlobalFilterChange} // Update the state on filter change
        globalFilter={globalFilter} // Pass the state variable to the table
        // renderTopToolbarCustomActions={({ table }) => (
        //   <div className="relative top-2 flex items-center gap-2">
        //     {!(
        //       searchComponent ||
        //       (searchComponentParams &&
        //         Object.keys(searchComponentParams).length > 0)
        //     ) && (
        //       <IoReloadOutline
        //         size={20}
        //         className={`cursor-pointer font-semibold hover:text-green-500 ${
        //           isLoading ? "animate-spin" : ""
        //         }`}
        //         onClick={() => {
        //           setColumnsFilterValue([]); // Reset all filters
        //           setGlobalFilter(""); // Reset global filter
        //           getEnquiryList(
        //             pagination.pageIndex,
        //             pagination.pageSize,
        //             "",
        //             {}
        //           ); // Refetch data without filters
        //         }}
        //       />
        //     )}
        //   </div>
        // )}
        // editingMode="modal" // Ensure this is correctly set
        // enableEditing // This should also be true
        renderRowActions={({ row }) => (
          <div className="flex flex-nowrap gap-4">
            <button
              className="text-xl text-primary"
              onClick={() =>
                window.open(
                  `mailto:${row.original.email}?subject=Hello ${row.original.customer_name}!`
                )
              }
            >
              <FaMailBulk />
            </button>
            <button
              className="text-xl text-success"
              onClick={() =>
                window.open(
                  `https://wa.me/${row.original.phone_number.replace(
                    /\D/g,
                    ""
                  )}?text=Hello ${row.original.customer_name}!`
                )
              }
            >
              <FaWhatsapp />
            </button>
          </div>
        )}
        renderDetailPanel={({ row }) => (
          <div style={{ padding: "6px" }} className="max-w-7xl">
            {row.original.children[row.original.children.length - 1].packages
              .length > 0 ? (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    {/* <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                      Enquiry ID
                    </th> */}
                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                      From
                    </th>
                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                      To
                    </th>
                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                      Departure Date
                    </th>
                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                      Created At
                    </th>
                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                      Package Type
                    </th>
                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                      Updated At
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {row.original.children[
                    row.original.children.length - 1
                  ].packages.map((pkg) => (
                    <tr key={pkg.enquiry_id}>
                      {" "}
                      {/* Use a unique identifier for the key */}
                      {/* <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                        {pkg.enquiry_id}
                      </td> */}
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                        {pkg?.fromAirport?.name}
                      </td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                        {pkg.toAirport?.name}
                      </td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                        {pkg.departure_date}
                      </td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                        {new Date(pkg.created_at).toLocaleString()}
                      </td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                        {pkg.package_type}
                      </td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                        {new Date(pkg.updated_at).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No packages available.</p> // Optional message when no packages are present
            )}
          </div>
        )}
      />
      {/* DaisyUI Modal */}
      {isModalInfoOpen && (
        <Modal
          heading="Special Requests"
          paragraph={selectedExperience}
          close={handleModalClose}
        />
      )}
    </section>
  );
}
